// Constants align with CSS Variables
export const OVERLAY_CLASSNAME_SELECTOR = '.dig-Overlay[class*="_overlay"]';
export const CHIPS_ROW_HEIGHT = 60;
export const BANNER_HEIGHT = 41;
export const BANNER_HEIGHT_EXTENSION_SIDE_PANEL = 10;
export const MAX_HEIGHT = 540;
export const CHIPS_ROW_HEIGHT_SELECTOR = "--omnibox__chips-row__height";
export const DROPDOWN_OPEN_HEIGHT_SELECTOR = "--omnibox-dropdown__open-height";
export const DROPDOWN_CLOSED_HEIGHT_SELECTOR =
  "--omnibox-dropdown__closed-height";
export const DROPDOWN_BANNER_HEIGHT_SELECTOR =
  "--omnibox-dropdown__banner-height";
export const DROPDOWN_MAX_HEIGHT_SELECTOR = "--omnibox-dropdown__max-height";
export const DROPDOWN_LAUNCHER_MAX_HEIGHT_SELECTOR =
  "--omnibox-dropdown__launcher__max-height";
